export default [
  {
    path: '/resize-images',
    name: 'resize',
    component: () => import('@/views/images/resize/index'),
    meta: {
      title: '尺寸变换|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、尺寸变换'
      }
    }
  },
  {
    path: '/rotate-images',
    name: 'rotate',
    component: () => import('@/views/images/flip/index'),
    meta: {
      title: '图片旋转|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、图片旋转'
      }
    }
  },
  {
    path: '/format-images',
    name: 'format',
    component: () => import('@/views/images/format/index'),
    meta: {
      title: '格式转换|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、格式转换'
      }
    }
  },
  {
    path: '/crop-images',
    name: 'crop',
    component: () => import('@/views/images/crop/index'),
    meta: {
      title: '图片裁剪|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、图片剪裁'
      }
    }
  },
  {
    path: '/text',
    name: 'text',
    component: () => import('@/views/images/text/index'),
    meta: {
      title: '添加文字|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、添加文字'
      }
    }
  },
  {
    path: '/watermark-images',
    name: 'watermark',
    component: () => import('@/views/images/watermark/index'),
    meta: {
      title: '添加水印|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、添加水印'
      }
    }
  },
  {
    path: '/puzzle-images',
    name: 'puzzle',
    component: () => import('@/views/images/puzzle/index'),
    meta: {
      title: '拼图|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、拼图'
      }
    }
  },
  {
    path: '/compress-images',
    name: 'compress',
    component: () => import('@/views/images/compress/index'),
    meta: {
      title: '图片压缩|图片编辑助手',
      content: {
        keywords: 'img助手、图片编辑助手、图片编辑'
      }
    }
  },
]



// WEBPACK FOOTER //
// ./src/vue/router/modules/images.js